import Authentication from './authentication';

export default Authentication;